import { useRequest } from "../../../app/hooks/useRequest";
import { endCaseHoldRequest } from "../CaseHoldRequests";

export const useEndCaseHold = () => useRequest(endCaseHoldRequest);
